import { render, staticRenderFns } from "./link-report.vue?vue&type=template&id=7338a2e4&scoped=true&"
import script from "./link-report.vue?vue&type=script&lang=js&"
export * from "./link-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7338a2e4",
  null
  
)

export default component.exports